export default __webpack_public_path__ + "static/media/poolpic2.bc11c68c.jpg";